//TODO: Is this module declaration needed at all?
import {NgModule} from '@angular/core';

@NgModule({
  declarations: [],
  imports: [],
  bootstrap: [],
})
export class HsLogModule {}
